import { spaNavigate } from "../actions"
import { newNotification } from "../store"

export function NotFoundError(type: string) {
    newNotification({
        class: "error",
        html: `${type} not found`,
    })
    spaNavigate("/404")
}
